import type { FC } from "react";
import type { Path } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { EmailDesignSchema } from "../../email-design/types/email-design-type";
import { CeColourField } from "../../generic/components/form-fields/ce-colour-field";
import { CeDropdown } from "../../generic/components/form-fields/ce-dropdown";
import { CeSlider } from "../../generic/components/form-fields/ce-slider";
import { FormStack } from "../../generic/components/form-fields/form-stack";

const DividerSettingsEditor: FC<{ type: "primary" | "secondary" }> = ({ type }) => {
  const name: Path<EmailDesignSchema> = `divider_settings.${type}`;
  const { t } = useTranslation();
  return (
    <FormStack>
      <CeColourField<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.color`}
        label={t("Color")}
      />
      <CeSlider<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.width`}
        label={t("Width")}
        min={1}
        max={10}
        step={1}
      />
      <CeDropdown<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.style`}
        label={t("Style")}
        options={[
          { label: t("Solid"), value: "solid" },
          { label: t("Dashed"), value: "dashed" },
          { label: t("Dotted"), value: "dotted" },
        ]}
      />
    </FormStack>
  );
};

export const PrimaryDividerSettingsEditor: FC = () => <DividerSettingsEditor type="primary" />;
export const SecondaryDividerSettingsEditor: FC = () => <DividerSettingsEditor type="secondary" />;
